export default "__VITE_ASSET__BypOXtkQ__"